import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid2,
  Plus1Icon,
  Typography,
} from "components";
import { motion } from "framer-motion";
import { map } from "lodash";
import { useFormContext, useWatch } from "react-hook-form";
import { WebsiteDetails } from "../types";

const FaqsSection = () => {
  const form = useFormContext<WebsiteDetails>();

  const faqs = useWatch({
    control: form.control,
    name: "websiteSection.faqs",
  });

  return (
    <Grid2
      container
      width={"100%"}
      spacing={10}
      maxWidth={{ xs: "100vw", md: "1192px" }}
    >
      <Grid2 size={12}>
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}>
          <Typography
            textAlign={"center"}
            fontSize={`clamp(1rem, -0.25rem + 4vw, 2rem)`}
            fontWeight={600}
          >
            Frequently asked questions{" "}
          </Typography>
        </motion.div>
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}>
          <Typography textAlign={"center"} fontSize={14} color="#697586">
            Everything you need to know about the product and billing.{" "}
          </Typography>
        </motion.div>
      </Grid2>
      <Grid2 size={12}>
        {map(faqs, (dataItem, index) => {
          return (
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              key={index}
            >
              <Accordion sx={{ boxShadow: "none" }} key={index}>
                <AccordionSummary
                  expandIcon={<Plus1Icon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography
                    component="span"
                    sx={{
                      color: "#000",
                    }}
                  >
                    {dataItem?.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography
                    color="#44484F"
                    dangerouslySetInnerHTML={{
                      __html: dataItem?.answer,
                    }}
                  />
                </AccordionDetails>
              </Accordion>
            </motion.div>
          );
        })}
      </Grid2>
    </Grid2>
  );
};

export default FaqsSection;
